export const MNO = 'mno';
export const MVNO = 'mvno';
export const MANUFACTURER = 'manufacturer';
export const OTHER = 'other';
export const UNDER_REVIEW = 'underReview';
export const ACC_REJECTED = 'rejected';

// AwaitingProductionApproval is deliberately NOT here: a Trial org that
// submitted a production upgrade request (UES-12111) keeps full portal
// access while the request is reviewed — its Test environment is unchanged.
export const REVIEWING_STATUS = {
  AwaitingApproval: UNDER_REVIEW,
  AwaitingApprovalBackoffice: UNDER_REVIEW,
  AwaitingPartnerApproval: UNDER_REVIEW,
  AwaitingOemApproval: UNDER_REVIEW,
};

export const REJECTED_STATUS = {
  Rejected: ACC_REJECTED,
  RejectedBackoffice: ACC_REJECTED,
  AwaitingOemRejection: ACC_REJECTED,
  OnlyPartnerRejected: ACC_REJECTED,
};
